import * as React from "react";
import {
  Box, Container, Typography, MenuItem, Select, FormControl, InputLabel,
} from "@mui/material";
import ButtonComponent from "components/Button";
import PropTypes from "prop-types";
import {
  schema,
  getButtonDataSendApproved,
  getButtonDataSendDisable,
  getButtonDataSendDelete,
  getButtonData,
  getTextfieldData,
  getSalesLogStatusOptions
} from "./helper";
import {checkUserAllowed, getImage, getLocalDate, openURL} from "helpers/utils";
import {H2, H4, H5} from "components/CustomTypography";
import TextFieldComponent from "components/TextField";
import {DATE_FORMAT, DATE_TIME_FORMAT_SHORT} from "config/constants";
import ImageAlbum from "components/elements/main/ImageAlbum";
import AdminShopSalesLogList from "components/elements/admin/shops/AdminShopSalesLogList";
import AdminSellerShopDetail from "components/elements/admin/shops/AdminSellerShopDetail";

import {useState} from "react";
import CustomSectionCreator from "components/CustomSectionCreator";
import ShopHeaderBack from "components/elements/main/ShopHeaderBack";
import AdminProductSearch from "components/widgets/admin/AdminProductSearch";

const AdminShopSalesLogSettingEditor = (props) => {

  const {
    updateSaleLogSettingClicked, cancelEdit, isLoading, userDetails, history, selectedSaleLog,
        onCancel, saleslog
  } = props;

  const {
     _id,
  } = selectedSaleLog;



  const [saleslogModeState, setSaleLogModeState] = useState("PREVIEW");
  const [selectedStatus, setSelectedStatus] = useState(saleslog?.status || "new");


  const onFinishApproved = () => {
    updateSaleLogSettingClicked({
      saleslog_id: _id, status: selectedStatus
    });
  };

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  const handleShopButtonClick = () => {
    setSaleLogModeState("SHOP_DETAIL");
  };

  const handleProductButtonClick = () => {
    setSaleLogModeState("EDIT_PROD");
  };

  const renderSalesLogUpdates = () => (
      <>
        <Box mb={2}>
          {(checkUserAllowed(userDetails.userlevel, "saleslogapprove")) && (
            <>
              <FormControl fullWidth variant="outlined" sx={{ mb: 2 }}>
                <InputLabel id="saleslog-status-label">Change Status</InputLabel>
                <Select
                  labelId="saleslog-status-label"
                  id="saleslog-status-select"
                  value={selectedStatus}
                  onChange={handleStatusChange}
                  label="Change Status"
                >
                  {getSalesLogStatusOptions().map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              
              {selectedStatus !== saleslog.status && getButtonDataSendApproved(onFinishApproved).map((element) => (
                  <ButtonComponent
                      key={element.name}
                      type={element.type}
                      variant={element.variant}
                      onClick={element.onClick}
                      disabled={element.disabled}
                      name={element.name}
                      size="medium"
                  />
              ))}
            </>
          )}
        </Box>
      </>
  );


  const renderSaleLogEntry = () => (
      <Container>
        <Box mb={2}>
          <Box width="100%" mb={2} alignItems="center" display="flex">
            <Box width="30%" >
              <H5 fontSize={14} textAlign="left" ellipsis>Status | Interest:</H5>
            </Box>
            <Box width="70%">
              {saleslog.status} ({saleslog.interest ? <b>{saleslog.interest}</b> : "NA"})
            </Box>
          </Box>
          <Box width="100%" mb={2} alignItems="center" display="flex">
            <Box width="30%" >
              <H5 fontSize={14} textAlign="left" ellipsis>Log Created:</H5>
            </Box>
            <Box width="70%">
              {getLocalDate(saleslog.created_at, DATE_TIME_FORMAT_SHORT)}
            </Box>
          </Box>
          <Box width="100%" mb={2} alignItems="center" display="flex">
            <Box width="30%" >
              <H5 fontSize={14} textAlign="left" ellipsis>Scope of Work:</H5>
            </Box>
            <Box width="70%">
              {saleslog.scope && saleslog.scope.join(' | ')}
            </Box>
          </Box>
          <Box width="100%" mb={2} alignItems="center" display="flex">
            <Box width="30%" >
              <H5 fontSize={14} textAlign="left" ellipsis>Message:</H5>
            </Box>
            <Box width="70%">
              {saleslog.message}
            </Box>
          </Box>
          <Box mb={2}>
            <ImageAlbum images={saleslog.images} mainOnly={true} />
          </Box>
          <Box width="100%" mb={2} alignItems="center" display="flex">
            <Box width="30%" >
              <H5 fontSize={14} textAlign="left" ellipsis>Products</H5>
            </Box>
            <Box width="70%">
              <ButtonComponent
                  type="primary"
                  variant="outlined"
                  name="View Products"
                  size="small"
                  onClick={handleProductButtonClick}
              />
            </Box>
          </Box>
        </Box>
        {(checkUserAllowed(userDetails.userlevel, "saleslogapprove")) && renderSalesLogUpdates()}

        {saleslog.shop && <AdminShopSalesLogList shopId={saleslog.shop._id} />}
      </Container>
  );

  const renderCategoryEdit = () => {
    switch (saleslogModeState) {

      case "EDIT_PROD":
        return (
            <>
              <CustomSectionCreator isSubtle={true} title="Shop Products" />
              <ShopHeaderBack  {...props} onCancel={() => setSaleLogModeState("PREVIEW")} />
              {saleslog.shop &&
                  <AdminProductSearch {...props}
                                      shopId={saleslog.shop._id}
                                      isShop={true}
                  />}
            </>
        );
    }
  }

  return (
      <Container>
        {saleslogModeState === "PREVIEW" ? (
            <>
              <ShopHeaderBack  {...props} onCancel={onCancel} />

              {renderSaleLogEntry()}

              <CustomSectionCreator isSubtle={true} title="Shop Information" />

              {saleslog.shop && <AdminSellerShopDetail {...props} shopId={saleslog.shop._id}/>}

              <CustomSectionCreator isSubtle={true} title="Shop Sales Log" />

            </>
        ) : (
            renderCategoryEdit(saleslogModeState)
        )}
      </Container>
  );
};

AdminShopSalesLogSettingEditor.propTypes = {
  setState: PropTypes.func.isRequired,
  offer: PropTypes.object.isRequired,
  updateOfferSettingClicked: PropTypes.func.isRequired,
  cancelEdit: PropTypes.func.isRequired,
};

export default AdminShopSalesLogSettingEditor;
